// extracted by mini-css-extract-plugin
export default {"Container":"SwipeableComponent_Container__rdyTu"};